import { cn } from "@babybjorn/ui";
import type { FC } from "react";
import Link from "../../../../components/general/Link";
import * as s from "./Breadcrumb.module.scss";

type BreadcrumbProps = {
	label: string;
	href?: string;
	isActive: boolean;
	hasSeparator?: boolean;
	position: string;
};

const Breadcrumb: FC<BreadcrumbProps> = ({
	label,
	href,
	isActive,
	hasSeparator,
	position,
}) => {
	if (!href)
		return (
			<li>
				<span
					className={cn(s.breadcrumb, {
						[s.active]: isActive,
						[s.separator]: hasSeparator,
					})}
				>
					{label}
				</span>
			</li>
		);

	return (
		<li
			itemProp="itemListElement"
			itemScope
			itemType="https://schema.org/ListItem"
		>
			<Link
				id={label}
				href={href}
				typeof="WebPage"
				itemProp="item"
				className={cn(s.breadcrumb, {
					[s.active]: isActive,
					[s.separator]: hasSeparator,
				})}
			>
				{label}
			</Link>
			<meta itemProp="position" content={position}></meta>
			<meta itemProp="name" content={label}></meta>
		</li>
	);
};

export default Breadcrumb;
